import React from "react";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import {closePopup, getValue} from "../../../static/js/Common2";
import {addMenuGrp, deleteMenu, menuGrpListChange, menuGrpModify} from "../../../static/js/service/menuService";
import MenuGroupDrag from "../../menu/MenuGroupDrag";
import removeBtn from "../../../static/image/v2/popup/removeBtn.png";

export default function MenuGrpPopupV2(props) {
  const shopId = props.shopId;
  const list = props.list;
  const reset = props.reset;
  const setReset = props.setReset;

  const closeBtnEvent = () => {
    document.getElementById("menuGrpNameInput").value = "";
    document.getElementById("menuGrpDesc").value = "";
    document.getElementById("menuGrpStates").checked = true;
    closePopup("menuGrpPopup1");
  }

  const addMenuGrpEvent = () => {
    let lastNumber;
    if(list.length > 0) {
      lastNumber = list[list.length - 1].visibleIndex;
    } else {
      lastNumber = 1;
    }

    const menuGrpName = getValue("menuGrpNameInput");
    const menuGrpDesc = getValue("menuGrpDesc");
    const menuGrpStates = document.getElementById("menuGrpStates").checked

    if(menuGrpName === "") {
      alert("그룹명을 입력해주세요.");
      return false;
    }

    const data = {
      shopId: shopId,
      addMenuGroupList: [{
        name: menuGrpName,
        desc: menuGrpDesc,
        visibleIndex: Number(lastNumber) + 1,
        isVisible: menuGrpStates
      }]
    }
    document.getElementById("menuGrp1Btn").setAttribute("disabled", true);
    addMenuGrp(shopId, data)
  }

  const menuGrpModifyEvent = () => {
    const menuGrpId = Number(getValue("modiMenuGrpId"));
    const menuGrpName = getValue("modiMenuGrpNameInput");
    const menuGrpDesc = getValue("modiMenuGrpDesc");
    const menuGrpStates = document.getElementById("modiMenuGrpStates").checked


    if(menuGrpName === "") {
      alert("그룹명을 입력해주세요.");
      return false;
    }

    const data = {
      menuGroupId: menuGrpId,
      name: menuGrpName,
      desc: menuGrpDesc,
      isVisible: menuGrpStates
    }
    document.getElementById("modiMenuGrpBtn").setAttribute("disabled", true);
    sessionStorage.setItem("targetId", `menuListBox${menuGrpId}`);
    menuGrpModify(shopId, menuGrpId, data)
  }

  const menuGrpListChangeEvent = () => {
    let dragData = document.querySelectorAll(".popupDragTitle");
    let data = [];

    dragData.forEach((value, index) => {
      data.push({
        menuGroupId: value.getAttribute("data-id"),
        visibleIndex: Number(index) + 1
      })
    })

    document.getElementById("menuGrp2Btn").setAttribute("disabled", true);
    menuGrpListChange(shopId, data);
  }

  const removeBoxArrowBtnEvent = (e, id) => {
    if(e.currentTarget.classList.contains("active")) {
      e.currentTarget.classList.remove("active");
      document.getElementById(id).classList.remove("active");
    } else {
      e.currentTarget.classList.add("active");
      document.getElementById(id).classList.add("active");
    }
  }

  const menuGrpBox = list.map(({id, name, menuList}) => {
    return (
      <div className="menuGrpRemoveBox grpRemoveBox" key={id}>
        <div id={`menuGrp${id}`} className="menuGrp">
          <input type='checkbox' className='menuGrpIndex' id={`menuGrpIndex${id}`} data-id={id} name='menuGrpIndex' />
          <label htmlFor={`menuGrpIndex${id}`}>{name}</label>
          <div className="removeMenuList">
            {menuList.map(({id, name}, index) => {
              let className = 'removeMenuBox removeBar'
              if(index === 0) {
                className = 'removeMenuBox removeBar topBorder'
              }

              return (
                <div className={className} key={id}>
                  <input className='removeMenu' id={`removeMenu${id}`} data-id={id} type='checkbox' name='removeMenuIndex' />
                  <label htmlFor={`removeMenu${id}`}>{name}</label>
                </div>
              )
            })}
          </div>
          <button className='removeBoxArrowBtn' onClick={(e) => removeBoxArrowBtnEvent(e, `menuGrp${id}`)}>
            <img src={ removeBtn } alt='' />
          </button>
        </div>
      </div>
    )
  })


  const menuRemoveEvent = () => {
    const removeGrpList = [];
    let removeMenuList = [];

    const removeGrpBox = document.querySelectorAll(".menuGrp");

    removeGrpBox.forEach((element) => {
      const removeGrp = element.querySelector(".menuGrpIndex");
      const removeGrpId = Number(removeGrp.getAttribute("data-id"));
      const removeMenu = element.querySelectorAll(".removeMenu");


      if(removeGrp.checked) {
        removeGrpList.push(removeGrpId);
        removeMenu.forEach((element) => {
          removeMenuList.push({
            grpId: removeGrpId,
            menuId: Number(element.getAttribute("data-id"))
          });
        });
      } else {
        removeMenu.forEach((element) => {
          if(element.checked) {
            removeMenuList.push({
              grpId: removeGrpId,
              menuId: Number(element.getAttribute("data-id"))
            });
          }
        });
      }
    });

    if(removeGrpList.length === 0 && removeMenuList.length === 0) {
      alert("삭제한 그룹/메뉴를 선택해주세요");
      return false;
    }

    document.getElementById("menuRemovePopupBtn").setAttribute("disabled", true);
    deleteMenu(shopId, removeGrpList, removeMenuList);
  }

  const menuRemoveCloseEvent = () => {
    const grpBox = document.querySelectorAll(".menuGrp");
    grpBox.forEach((element) => {
      element.querySelector(".menuGrpIndex").checked = false;
      element.classList.remove("active");
      element.querySelector(".removeBoxArrowBtn").classList.remove("active");
      const removeMenuBox = element.querySelectorAll(".removeMenu");
      removeMenuBox.forEach((element) => {
        element.checked = false;
      })
    })
    closePopup("menuRemovePopup1")
  }


return (
    <div>
      <div id="menuGrpPopup1" className="menuGrpPopup1 popupV2 hide">
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>그룹 추가</h2>
            <button className='closeBtn' onClick={() => closeBtnEvent()}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>그룹명</div>
              <div className='flexContent'>
                <input type='text' id='menuGrpNameInput' placeholder='그룹명 입력' />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <div className='flexTitle'>그룹 설명</div>
              <div className='flexContent'>
                <textarea id='menuGrpDesc' placeholder='그룹 설명 입력' />
              </div>
            </div>
            <div className='popupFlexBox'>
              <div className='flexTitle'>그룹 상태</div>
              <div className='flexCheckBox'>
                <input type='checkbox' id='menuGrpStates' name='menuGrpStates' defaultChecked={true} />
                <label htmlFor="menuGrpStates">노출함</label>
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closeBtnEvent()}>취소</button>
            <button type='button' id="menuGrp1Btn" className='menuGrp1Btn blueBtn' onClick={() => addMenuGrpEvent()}>확인</button>
          </div>
        </div>
      </div>

      <div id="modiMenuGrpPopup" className='modiMenuGrpPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>그룹 수정</h2>
            <button className='closeBtn resetBtn' onClick={() => closePopup("modiMenuGrpPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>그룹명</div>
              <div className='flexContent'>
                <input type='text' id='modiMenuGrpNameInput' placeholder='그룹명 입력' />
                <input type='hidden' id='modiMenuGrpId' />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <div className='flexTitle'>그룹 설명</div>
              <div className='flexContent'>
                <textarea id='modiMenuGrpDesc' placeholder='그룹 설명 입력' />
              </div>
            </div>
            <div className='popupFlexBox'>
              <div className='flexTitle'>그룹 상태</div>
              <div className='flexCheckBox'>
                <input type='checkbox' id='modiMenuGrpStates' name='modiMenuGrpStates' />
                <label htmlFor="modiMenuGrpStates">노출함</label>
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closePopup("modiMenuGrpPopup")}>취소</button>
            <button type='button' id="modiMenuGrpBtn" className='modiMenuGrpBtn blueBtn' data-id="" onClick={() => menuGrpModifyEvent()}>확인</button>
          </div>
        </div>
      </div>

      <div id="menuGrpPopup2" className='menuGrpPopup2 popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>그룹 순서 변경</h2>
            <button className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
              closePopup("menuGrpPopup2");
              setReset(false);
            }}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupDragBox'>
              <MenuGroupDrag items={list} reset={reset} />
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
              closePopup("menuGrpPopup2");
              setReset(false);
            }}>취소</button>
            <button type='button' id="menuGrp2Btn" className='menuGrp2Btn blueBtn' onClick={() => menuGrpListChangeEvent()}>확인</button>
          </div>
        </div>
      </div>

      <div id="menuRemovePopup1" className='menuRemovePopup1 resetPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>그룹/메뉴 삭제</h2>
            <button className='closeBtn resetBtn' onClick={() => menuRemoveCloseEvent()}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            {menuGrpBox}
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn resetBtn' onClick={() => menuRemoveCloseEvent()}>취소</button>
            <button type='button' id="menuRemovePopupBtn" className='menuRemovePopupBtn blueBtn' onClick={() => menuRemoveEvent()}>확인</button>
          </div>
        </div>
      </div>
    </div>
  )
}